/**
 * Recognized projects the user has not looked over yet: the editor says «Проверьте результат» on opening one, as the
 * app shows its check dialog after a recognition below 97 (`ShowRecognitionResultCheckDialog`), and forgets it once
 * dismissed. Held for this tab only, as the app's flag lives until the editor closes.
 */
import type { FloorStatus } from './protocol';
import { cultureName, t, type TranslationKey } from '../i18n/I18n';

export interface RecognitionCheck { score: number; floors: FloorStatus[]; onPlan: boolean }

const pending = new Map<string, RecognitionCheck>();
const listeners = new Set<() => void>();
const emit = () => { for (const listener of listeners) listener(); };

export const recognitionChecks = {
  add(projectId: string, check: RecognitionCheck): void { pending.set(projectId, check); emit(); },
  get(projectId: string | null | undefined): RecognitionCheck | null { return projectId ? pending.get(projectId) ?? null : null; },
  dismiss(projectId: string): void { if (pending.delete(projectId)) emit(); },
  subscribe(listener: () => void): () => void { listeners.add(listener); return () => { listeners.delete(listener); }; },
};

const FLOOR_PROBLEMS: Partial<Record<FloorStatus['state'], TranslationKey>> = {
  not_recognized: '#RecognitionFloorNotRecognized', timed_out: '#RecognitionFloorTimedOut', scale_not_matched: '#RecognitionFloorScaleNotMatched',
};

/** The words under «Проверьте результат»: the app's advice, and which floors did not come through. */
export function checkMessage(check: RecognitionCheck): string {
  const floors = check.floors.filter(floor => FLOOR_PROBLEMS[floor.state]).map(floor => t(FLOOR_PROBLEMS[floor.state]!, floor.index + 1));
  const base = t('#RecognitionCheckAdvice'), list = floors.join('; ');
  return floors.length ? `${base} ${list.charAt(0).toLocaleUpperCase(cultureName())}${list.slice(1)}.` : base;
}
